import React, { useRef, useEffect, useState } from 'react';

import { useCollectionData } from 'react-firebase-hooks/firestore';
import TextareaAutosize from 'react-textarea-autosize';
import Loading from 'react-loading';

import './App.css';

import sendImage from './images/send.svg';


function ChatRoom({ firestoreClient }) {
    const dummy = useRef();

    const [messages] = useCollectionData(firestoreClient.lastMessagesQuery, { idField: 'id' });

    // Create a state to manage whether the bot is typing or not
    const [isBotTyping, setIsBotTyping] = useState(true);

    const [formValue, setFormValue] = useState('');

    useEffect(() => {
        let typingTimeout;  // To keep the reference of the timeout
    
        if (!messages) {
            // console.log('messages is null or undefined');
            return;
        }
    
        console.log(messages);
        if (!(messages[0]?.isBot)) { // && messages.length > 0 // first message bubbles
            typingTimeout = setTimeout(() => setIsBotTyping(true), 1000);  // Start the timer
        } else {
            setIsBotTyping(false);
        }
    
        // Clear timeout when unmounting or when messages change
        return () => clearTimeout(typingTimeout);
    }, [messages]);

    const sendMessage = async (e) => {
        e.preventDefault();
        await firestoreClient.createUserMessage(formValue);
        setFormValue('');
        dummy.current.scrollIntoView({ behavior: 'smooth' });
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            sendMessage(e);
        }
    }

    return (
        <div className="flex flex-col h-full">
            <main className="px-6 py-4 overflow-y-scroll pb-16 flex-grow flex flex-col-reverse">
                <span ref={dummy}></span>
                {isBotTyping && <Loading type={'bubbles'} color={'#000000'} height={'20%'} width={'20%'}/>}
                {messages && messages?.map(msg => <ChatMessage key={msg.id} message={msg} />)}
            </main>
            <form className="sticky bottom-0 z-10 flex items-center justify-between px-4 py-3 bg-[#F49201]" onSubmit={sendMessage}>
                <TextareaAutosize
                    className="w-full rounded-md border border-gray-300 px-4 py-2 max-h-[50vh] overflow-auto"
                    value={formValue}
                    onChange={(e) => setFormValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    placeholder="hier tippen ..."
                />
                <button className="ml-4 flex-shrink-0" type="submit" disabled={!formValue}>
                    <img className="h-6" src={sendImage} alt="💬" />
                </button>
            </form>
        </div>
    );
    

}


function ChatMessage(props) {
    const text = props.message.text
    const isBot = props.message.isBot

    const formattedText = text.split('\n').map((line, index) => (
        <React.Fragment key={index}>
            {line}
            <br />
        </React.Fragment>
    ));

    let messageClass;
    if (isBot) {
        messageClass = 'received';
    } else {
        messageClass = 'sent';
    }

    return (
        <div className={`flex ${messageClass === 'sent' ? 'justify-end' : 'justify-start'} mb-4`}>
            <div className={`bubble inline-block ${messageClass === 'sent' ? 'bg-white text-gray-800 p-3 rounded-l-md rounded-br-md' : 'bg-[#F49201] text-white p-3 rounded-r-md rounded-bl-md'} max-w-[80%] overflow-auto break-words`}>
                {formattedText}
            </div>
        </div>
    );
}


export default ChatRoom;